import { useState } from "react";
import AttachmentLink from "./AttachmentLink"

const AttachmentLinkContainer = (props:any) =>{
    const [visible, setVisible] = useState<boolean>(false);
    const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
    const [linkAttachmentId, setLinkAttachmentId] = useState();

    const onLinkAttachmentClicked = (i: any) => {
        let attachments = [...isAttachmentBtnClicked];
        attachments[i] = true;
        setIsAttachmentBtnClicked(attachments);
        setLinkAttachmentId(i);
        setVisible((prev) => !prev)
      };
    
      const onLinkAttachmentClosed = (i: any) => {
        let attachments = [...isAttachmentBtnClicked];
        attachments[i] = false;
        setIsAttachmentBtnClicked(attachments);
        setLinkAttachmentId(i);
        setVisible((prev) => !prev)
      };

      const onClickAttachment = (item: any) => {
        let win = window.open();
        if (win) {
          win.document.write(
            '<iframe width="100%" height="100%" src="' +
              item +
              '" frameborder="0" ></iframe>'
          );
        }
      };

    return(
        <AttachmentLink
           item = {props.item}
           index = {props.index} 
           itemLevel = {props.itemLevel}     
            isAttachmentBtnClicked={isAttachmentBtnClicked}
            setIsAttachmentBtnClicked={setIsAttachmentBtnClicked}
            linkAttachmentId={linkAttachmentId}
            setLinkAttachmentId={setLinkAttachmentId}
            onLinkAttachmentClicked={onLinkAttachmentClicked}
            onLinkAttachmentClosed={onLinkAttachmentClosed}
            onClickAttachment={onClickAttachment}
            visible={visible}
            setVisible={setVisible}
            requesttype = {props.requesttype}            
        />
    )
}

export default AttachmentLinkContainer